module.exports = __webpack_public_path__ + "static/main2_sp-b474e113c357c8653ebfcdaba987f09f.jpg";